module.exports = __webpack_public_path__ + "static/media/bg-contato.b09a3bdf.png";